import {
  BlockStack,
  Button,
  Icon,
  Image,
  InlineStack,
  LegacyStack,
  Text,
  useBreakpoints,
} from '@shopify/polaris'
import { PlayIcon } from '@shopify/polaris-icons'
import { useState } from 'react'

import { useDialogActivator } from '../common/helpers'
import { VideoModal } from '../common/VideoModal'
import { InstallSubscriptionWidgetContent } from '../settings-page/SubscriptionWidgetCard'
import { FreeSetupBanner } from './GettingStarted'

export const InstallSubscriptionWidget = ({
  onComplete,
  onSkip,
}: {
  onComplete: () => void
  onSkip: () => void
}) => {
  const { mdUp } = useBreakpoints()
  const [addWidgetClicked, setAddWidgetClicked] = useState(false)
  const videoActivator = useDialogActivator()

  const handleDone = () => {
    addWidgetClicked ? onComplete() : onSkip()
  }

  return (
    <>
      <BlockStack gap="400">
        <Text variant="headingMd" as="h2" fontWeight="bold">
          Quick Start - Install subscription widget
        </Text>
        <BlockStack gap="600">
          <FreeSetupBanner />
          <InlineStack gap="400" wrap={false} blockAlign="center">
            <LegacyStack.Item fill>
              <BlockStack gap="400">
                <Text as="p">
                  Almost there! Now add a subscription plan widget to your product pages, to allow
                  your customers to purchase your subscriptions.
                </Text>
                <InstallSubscriptionWidgetContent
                  onAddWidgetClick={() => setAddWidgetClicked(true)}
                />
              </BlockStack>
            </LegacyStack.Item>
            {mdUp && (
              <LegacyStack.Item>
                <Image
                  style={{ maxWidth: '120px', margin: '0 70px' }}
                  source="/images/drag-and-drop.svg"
                  alt="Start Selling"
                />
              </LegacyStack.Item>
            )}
          </InlineStack>
          <InlineStack gap="200">
            <Button onClick={handleDone} variant="primary">
              Done
            </Button>
            <Button onClick={videoActivator.show} icon={<Icon source={PlayIcon} tone="base" />}>
              Watch video
            </Button>
          </InlineStack>
        </BlockStack>
      </BlockStack>
      <VideoModal
        src="https://www.youtube.com/embed/_3T-2NMNxvs"
        title="How To Install The PayWhirl Subscription Widget"
        activator={videoActivator}
      />
    </>
  )
}
